import {logger} from '../services/logger';
import {CMP_SSP_IFRAME_URL, SSP_SYNC_URL, USER_INT} from '../constants';

let syncIframe = null;

/**
 * it creates communication iframe with ssp.imedia.cz domain
 * @returns {promise} promise with iframe
 */
const createISyncframe = () =>
  new Promise(resolve => {
    if (syncIframe) {
      return resolve(syncIframe);
    }

    syncIframe = document.createElement('iframe');
    syncIframe.src = SSP_SYNC_URL;
    syncIframe.frameBorder = 0;
    syncIframe.style.display = 'none';
    syncIframe.onload = () => {
      logger(1300, 'Sync iframeloaded');
      resolve(syncIframe);
    };
    document.body.appendChild(syncIframe);
  });

const parseSyncIframeResponseDone = (e, resolve, reject) => {
  let data = {};

  try {
    data = JSON.parse(e.data);
  } catch (error) {
    return false;
  }

  if (data.cmp && data.cmp === 'szn') {
    if (data.method === 'get') {
      if (data.cookie) {
        logger(1301, 'Got cookie from global storage.', data.cookie);
      } else {
        logger(1302, 'Got no cookie from global.');
      }
      resolve(data.cookie);
      return true;
    }

    if (data.method === 'set') {
      if (data.confirm) {
        logger(1303, 'Set cookie to global storage - succeded.');
      } else {
        logger(1304, 'Set cookie to global storage - failed.');
      }

      resolve(data.confirm);
      return true;
    }

    logger(1305, 'Communication with global failed.');
    reject();
    return true;
  }

  return false;
};

export const messageListener = (resolve, reject) => e => {
  if (parseSyncIframeResponseDone(e, resolve, reject)) {
    window.removeEventListener('message', this);
  }
};

/**
 *
 * @param {string} cookie user type
 * @returns {promise} with cookie
 */
export const getCookieFromGlobalStorage = (userType = USER_INT) =>
  new Promise(async (resolve, reject) => {
    const iframe = await createISyncframe();

    logger(1306, 'Sending message to iframe: getCookie');

    window.addEventListener('message', messageListener(resolve, reject));
    // send to iframe
    const type = userType.toLowerCase();
    iframe.contentWindow.postMessage(JSON.stringify({method: 'getCookie', type}), CMP_SSP_IFRAME_URL);

    // if response fail
    setTimeout(() => {
      reject();
    }, 5000);
  });

/**
 *
 * @param {string} cookie  local cookie string
 * @returns {promise} with info message
 */
export const setCookieToGlobalStorage = (cookie, userType = USER_INT) =>
  new Promise(async (resolve, reject) => {
    const iframe = await createISyncframe();

    logger(1307, 'Sending message to iframe: setCookie');

    window.addEventListener('message', messageListener(resolve, reject));
    // send to iframe
    const type = userType.toLowerCase();
    iframe.contentWindow.postMessage(JSON.stringify({method: 'setCookie', type, cookie}), CMP_SSP_IFRAME_URL);

    // if response fail
    setTimeout(() => {
      reject();
    }, 5000);
  });

/**
 *
 * @param {string} cookie euconsent
 * @returns {promise} with cookie
 */
export const getTcf2FromGlobalStorage = (userType = USER_INT) =>
  new Promise(async (resolve, reject) => {
    const iframe = await createISyncframe();

    logger(1306, '[TCF2.0] Sending message to iframe: getCookie');

    window.addEventListener('message', messageListener(resolve, reject));
    // send to iframe
    const type = userType.toLowerCase();
    iframe.contentWindow.postMessage(JSON.stringify({method: 'getCookie', type, v2: true}), CMP_SSP_IFRAME_URL);

    // if response fail
    setTimeout(() => {
      reject();
    }, 5000);
  });

/**
 *
 * @param {string} cookie local cookie string
 * @returns {promise} with info message
 */
export const setTcf2ToGlobalStorage = (cookie, userType = USER_INT) =>
  new Promise(async (resolve, reject) => {
    const iframe = await createISyncframe();

    logger(1307, '[TCF2.0] Sending message to iframe: setCookie');

    window.addEventListener('message', messageListener(resolve, reject));
    // send to iframe
    const type = userType.toLowerCase();
    iframe.contentWindow.postMessage(JSON.stringify({method: 'setCookie', type, cookie, v2: true}), CMP_SSP_IFRAME_URL);

    // if response fail
    setTimeout(() => {
      reject();
    }, 5000);
  });
